import store_config from '@/store/mods/parametres/config'
import draggable from 'vuedraggable';
import $ from 'jquery'

export default {
    name: 'manage-tri-urgence',
    components: {
        draggable
    },
    props: {
        toggler: Number,
        selected_tri: Object,
        liste_tri_urgence: Array
    },

    data() {
        return {
            param_tri: {
                libelle: '',
                code_couleur: '#000000',
                description: ''
            },

            save_loading: false,
            msg_error: '',
            del_loading: false,
            is_confirm: false
        }
    },

    watch: {
        toggler() {
            this.del_loading=  false,
            this.is_confirm = false
            $('.err-msg').fadeOut();
            this.resetForm()
        }
    },

    computed: {

    },

    mounted() {

    },

    methods: {
        onChoose: function($event) {
            console.log($event);
        },

        resetForm() {
            this.param_tri = {
                libelle: this.selected_tri.libelle,
                code_couleur: this.selected_tri.code_couleur,
                description: this.selected_tri.description,
                data_type: 'tri_urgence'
            }

            this.msg_error = ''
            this.save_loading = false
        },

        async saveNiveauTriUrgence() {
            const isValid = await this.$refs.tri_urgence_form.validate();
            if (!isValid) {
                return;
            }
            
            const data = {
                niveau_tri_urgence_id: this.selected_tri.niveau_tri_urgence_id,
                libelle: this.param_tri.libelle,
                code_couleur: this.param_tri.code_couleur,
                description: this.param_tri.description,
                data_type: this.param_tri.data_type
            }

            this.save_loading = true
            store_config.saveTriUrgence(data).then((response) => {
                if (response.success) {
                    this.$refs.tri_urgence.click()
                    this.$refs.tri_urgence_form.reset();
                    this.$emit("emitRefreshTriUrgence")
                    this.successToast(response.message)
                } else {
                    this.msg_error = response.message
                }

                this.save_loading = false
            }).catch(() => {
                this.save_loading = false
                this.msg_error = "Une erreur est survenue lors de la sauvegarde des données"
            })
        },

        saveTriOrder() {
            let champs = []
            this.liste_tri_urgence.forEach(tri => {
                const tmp_tri = {
                    id: tri.niveau_tri_urgence_id,
                    order: tri.ordre
                }
                champs.push(tmp_tri)
            });

            const data = {
                champs: champs
            }

            this.save_loading = true
            store_config.reOrderTriUrgence(data).then((response) => {
                if (response.success) {
                    this.$emit('emitRefreshTriUrgence')
                    this.$refs.order_niveau_tri.click()
                    this.successToast(response.message)
                } else {
                    this.msg_error = response.message
                }
                this.save_loading = false
            }).catch(() => {
                this.save_loading = false
                this.msg_error = "Une erreur s'est produite !"
            })
        },


         /**
         * Cache le message d'erreur au click du checkbox
         */
        onConfirm() {
            $('.err-msg').fadeOut(500);
        },

        confirmer() {
            this.is_confirm = true
        },


        supprimer(selector) {
            let confirm = document.getElementById(selector);
            
            if (confirm.checked == false) { //  Vérifie si l'utilisateur a confirmé la cloture
                $('.err-msg').fadeIn(500)
                return
            }

            console.log("Delete: ",this.selected_tri);
            
            this.del_loading = true;
            store_config.deleteTriUrgence(this.selected_tri).then((response) => {
                if (response > 0) {
                    this.successToast("Suppression effectuée avec succès")
                    this.$emit('emitRefreshTriUrgence')
                    this.$refs.del_tri_urgence.click();
                }

                this.del_loading = false
            }).catch(() => {
                this.del_loading = false
                this.msg_error = "Une erreur s'est produite !"
            })
        },
    }
}